var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({style:({
    transform: _vm.zoom !== 1 ? ("scale(" + _vm.zoom + ")") : undefined,
    padding: typeof _vm.padding === 'number' ? (_vm.padding + "px") : _vm.padding,
  }),domProps:{"innerHTML":_vm._s(_vm.svgChildren)}},'svg',Object.assign({}, _vm.svgAttributes, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }